// "Spot the Slip" expansion — FAMILY theme. Shape:
//   [ wrong, right, tag, why, slug ]

export const CORRECTIONS_FAMILY = [
  ["O meu pai é reformado e muito feliz.", "O meu pai está reformado e muito feliz.", "ser-estar",
    "Estar reformado describes a current life-state → estar.", "ser-vs-estar"],
  ["Os meus pais são divorciados desde 2019.", "Os meus pais estão divorciados desde 2019.", "ser-estar",
    "A resulting marital state uses estar → estão divorciados.", "ser-vs-estar"],
  ["O casamento é na igreja da aldeia.", "O casamento é na igreja da aldeia.", "ser-estar",
    "Trap check: an event 'taking place' correctly uses ser. (Already correct!)", "ser-vs-estar"],
  ["A minha sogra é muito amável, está uma boa cozinheira.", "A minha sogra é muito amável e é uma boa cozinheira.", "ser-estar",
    "A defining role (being a good cook) is identity → ser.", "ser-vs-estar"],
  ["Tenho um sobrinha muito esperta.", "Tenho uma sobrinha muito esperta.", "gender",
    "Sobrinha is feminine; use uma.", "gender-agreement-of-nouns"],
  ["A minha prima é alto e magro.", "A minha prima é alta e magra.", "gender",
    "Feminine subject → alta e magra.", "adjective-agreement"],
  ["Os pais da Maria são muito unido.", "Os pais da Maria estão muito unidos.", "gender",
    "Plural agreement plus the close-knit state → estão muito unidos.", "adjective-agreement"],
  ["Eu gosto de os meus primos do Porto.", "Eu gosto dos meus primos do Porto.", "gustar",
    "Gostar takes de; de + os = dos.", "gostar-and-similar-verbs"],
  ["Faz-me falta os meus irmãos quando viajo.", "Fazem-me falta os meus irmãos quando viajo.", "gustar",
    "Fazer falta agrees with its plural subject → fazem.", "gostar-and-similar-verbs"],
  ["Comprei um presente pela minha madrinha.", "Comprei um presente para a minha madrinha.", "por-para",
    "A gift's recipient takes para, not por.", "por-vs-para"],
  ["Obrigada para acolher o meu sobrinho.", "Obrigada por acolher o meu sobrinho.", "por-para",
    "Cause or motive ('thanks for') takes por.", "por-vs-para"],
  ["Quando éramos pequenos, fomos a casa da avó todos os verões.", "Quando éramos pequenos, íamos a casa da avó todos os verões.", "preterito-imperfecto",
    "A repeated childhood habit is the imperfeito → íamos.", "a2-preterito-vs-imperfeito"],
  ["O bebe da minha prima nasceu em março.", "O bebé da minha prima nasceu em março.", "accents",
    "Bebé is oxytone ending in a vowel, so it needs the accent.", "stress-and-written-accents"],
  ["Espero que a minha família vem ao casamento.", "Espero que a minha família venha ao casamento.", "subjunctive",
    "Esperar que (hope) flips the verb to the conjuntivo → venha.", "b1-present-subjunctive"],
  ["Quero que os meus filhos se dão bem.", "Quero que os meus filhos se deem bem.", "subjunctive",
    "A wish about others (querer que) triggers the conjuntivo → se deem.", "b1-present-subjunctive"],
];
